'use client';
import { useEffect } from 'react';
import FooterSection from '../FooterSection';
import Image from 'next/image';

const ContactSection = () => {
   useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.onload = () => {
      if ((window as any).hbspt) {
        (window as any).hbspt.forms.create({
           portalId: "43968755",
          formId: "701fbb5a-9068-458a-94e8-130babe517ab",
          region: "na1",
          target: '#hubspot-form'
        });
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
    <section 
      className="w-full bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/images/contact-bg.webp')" }}
    >
      <div className="w-full max-w-[1460px] mx-auto px-[20px] sm:px-[40px] md:px-[100px] pt-[80px] sm:pt-[100px] md:pt-[140px] pb-[60px] sm:pb-[90px] md:pb-[120px]">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-[100px]">
          
          {/* Left Column - HubSpot Form */}
          <div className="flex flex-col gap-[30px] sm:gap-[45px] md:gap-[60px] w-full lg:flex-1">
            <h1 className="text-[33px] sm:text-[49px] md:text-[66px] font-bold leading-[33px] sm:leading-[49px] md:leading-[66px] text-center text-black capitalize">
              Get in touch
            </h1>

            <div
              id="hubspot-form"
              className="w-full bg-white p-[20px] sm:p-[30px] md:p-[40px] rounded-[20px] border border-gray-200 shadow-md"
            ></div>
          </div>
          
        </div>
      </div>
      {/* <FooterSection /> */}
    </section>
  );
};

export default ContactSection;
